"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("el-button", {
    staticStyle: {
      "margin-bottom": "2px",
      width: "120px"
    },
    attrs: {
      type: "info",
      size: "mini",
      disabled: ""
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.timeRemaining))])])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;